import { ICONS } from "@constants/images";

const StylishStat = (props: any) => {
  const { title, value } = props;
  return (
    <div className="stylish-stat-wrapper wow animate__animated animate__fadeInUp animate__delay-1s">
      <div className="stylish-stat-heading">{title}</div>
      <div className="stylish-stat-info">
        <div className="stylish-stat-info-value">{value}+</div>
        <img className="stylish-stat-info-icon" src={ICONS.ICON}></img>
      </div>
    </div>
  );
};

export default StylishStat;
